import React from 'react';
import '../index.css';
import Socials from './Socials';
import { profileData } from '../data';

const Footer = () => {
  return (
    <footer className="overflow-hidden bg-black border-t text-neutral-200 border-midground">
      <div className="pt-10 pb-0 sm:border-x border-neutral-200 section-padding sm:pt-16 layout">
        {/* Top Section: Email & Socials */}
        <div className="flex flex-col-reverse flex-wrap items-center justify-between sm:items-start sm:flex-row gap-y-5">
          <div className="flex flex-row flex-wrap justify-between gap-3 sm:flex-col">
            <h2 className="hidden sm:inline text-slate-400">Email</h2>
            <a
              href={`mailto:${profileData.socials.contactEmail}`}
              className="font-semibold transition duration-300 font-inter sm:font-bold hover:text-white"
            >
             {profileData.socials.contactEmail}
            </a>
          </div>
          <div className="flex flex-col flex-wrap items-center justify-between sm:items-start gap-y-2">
            <h2 className="hidden sm:inline text-slate-400">Social</h2>
            <Socials />
          </div>
        </div>

        {/* Middle Section: Copyright & Location */}
        <hr className="h-px border-0 bg-neutral-300 my-7" />

        <div className="flex flex-col items-center pb-5 sm:py-0 sm:flex-row sm:justify-between">
          <p className="text-sm text-foreground-accent sm:text-slate-400">Based in Oslo, Norway.</p>
          <p className="text-base font-semibold sm:text-sm text-slate-400 sm:font-normal">
            © {new Date().getFullYear()} {profileData.profile.full_name}
          </p>
        </div>

        {/* Bottom Section: Name Title */}
        <div className="
          relative hidden sm:flex flex-row flex-wrap justify-between font-bold text-white uppercase blur-gradient 
          sm:top-5 md:top-7 lg:top-10 xl:top-12 sm:text-[46px] md:text-[66px] lg:text-[90px] xl:text-[90px] 2xl:text-[110px]
        ">
          <p>Danny</p>
          <p>Thinh</p>
          <p>Tran</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;